import {
  IGetBetsPositionRequest,
  ECategory,
  EGeoType,
  EConcurrencyType,
} from '../../../../../repositories/auction/v1/get-bets-position';
import { getIsCommercial } from '../../../../../utils/category/getIsCommercial';
import {
  IGeoAddress,
  IOfferState,
  EServiceId,
  ICoordinates,
  IServicePackage,
  EPlacingType,
} from '../../../../reducers';
import { getBetPositionServices } from './getBetPositionServices';

export interface IGetBetPositionParams {
  serviceIds: EServiceId[];
  packages: IServicePackage[];
  offer: IOfferState;
  childLocation: IGeoAddress | null;
  coordinates: ICoordinates;
  currentBet: number;
  isAuctionEnabled: boolean;
  isPromotionPackageSelected: boolean;
  extraData: object;
  activePlacingType: EPlacingType | null;
  diffPricesPackageEnabled: boolean;
}

export function getBetPositionParams(params: IGetBetPositionParams): IGetBetsPositionRequest {
  const {
    serviceIds,
    packages,
    offer: { category, id, bargainTerms, totalArea, areaParts },
    childLocation,
    coordinates: { lat, lng },
    currentBet,
    isAuctionEnabled,
    isPromotionPackageSelected,
    extraData,
    activePlacingType,
    /**
     * @todo Удалить строку с RS
     * @description Данный функционал появился в задаче CD-166174, будет удалён в задаче CD-166304
     */
    diffPricesPackageEnabled,
  } = params;

  const geoId = childLocation?.id || undefined;
  const geoType = (childLocation?.type as unknown as EGeoType) || undefined;

  const packageIds = packages.map(item => item.serviceId);

  const services = getBetPositionServices({
    serviceIds,
    packageIds,
    currentBet,
    isAuctionEnabled,
    isPromotionPackageSelected,
  });

  const result: IGetBetsPositionRequest = {
    concurrencyType: EConcurrencyType.Local,
    announcementId: id,
    price: bargainTerms.price,
    geoId,
    geoType,
    category: category as ECategory | null,
    services,
    lat,
    lon: lng,
    extraData,
  };

  const isCommercial = !!category && getIsCommercial(category);

  const isPackageOnUi = activePlacingType ? activePlacingType === EPlacingType.package : null;

  if (isCommercial) {
    Object.assign<IGetBetsPositionRequest, Partial<IGetBetsPositionRequest>>(result, {
      currency: bargainTerms && bargainTerms.currency,
      priceType: bargainTerms && bargainTerms.priceType,
      paymentPeriod: bargainTerms && bargainTerms.paymentPeriod,
      totalArea,
      multiListingSlotsCount: areaParts?.length ?? null,
      /**
       * @todo Удалить строку с RS
       * @description Данный функционал появился в задаче CD-166174, будет удалён в задаче CD-166304
       */
      ...(diffPricesPackageEnabled && { isPackageOnUi }),
    });
  }

  return result;
}
